module.exports = __webpack_public_path__ + "assets/img/empty-EN.3c06826d.png";